module.exports = __webpack_public_path__ + "img/6182421a9ec94822a33d513f1add9246.d1e7eeb9.jpg";